import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";

export default function RegisterPage() {

    const { t } = useContext(TranslatorContext);
    
    return (
        <div className="mc-register">
            <div className="mc-register-banner">
                <img 
                    className="mc-register-banner-pattern" 
                    src="images/fsf.png"
                    alt="pattern"
                />
               
            </div>
            <form className="mc-register-form">
                <LogoComponent 
                    src="images/logo.webp"
                    alt="logo" 
                    href="/ecommerce"
                    className="mc-auth-logo"
                />
                <h4 className="mc-auth-title">Register a new account</h4>
                
                <IconFieldComponent 
                    icon="email"
                    type="email"
                    classes="h-sm"
                    placeholder={t('enter_your_email')}
                />
                <IconFieldComponent 
                    icon="lock"
                    type="password"
                    classes="h-sm"
                    placeholder={t('enter_your_password')}
                    passwordVisible={true}
                />
               
               
                <ButtonComponent className="mc-auth-btn h-sm" type="button">{t('sign_in')}</ButtonComponent>
                <div className="mc-auth-divide"><span>{t('or')}</span></div>
                
                
            </form>
        </div>
    )
}